import type { OrderItem } from '@shop-monorepo/types';
import React from 'react';
import styled from 'styled-components';

import { formatPrice } from '../utils/currency';

import { ProductLink } from './ProductLink';

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #edf2f7;

  &:last-child {
    border-bottom: none;
  }
`;

const CardImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background: #f1f5f9;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CardMeta = styled.div`
  font-size: 13px;
  color: #64748b;
`;

const CardTotal = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  flex-shrink: 0;
`;

interface OrderItemMobileCardProps {
  item: OrderItem;
}

export const OrderItemMobileCard: React.FC<OrderItemMobileCardProps> = ({ item }) => (
  <Card>
    <CardImage>{item.image && <img src={item.image} alt={item.productName} />}</CardImage>
    <CardBody>
      <ProductLink slug={item.productId}>{item.productName}</ProductLink>
      <CardMeta>
        {formatPrice(item.price)} × {item.quantity}
      </CardMeta>
    </CardBody>
    <CardTotal>{formatPrice(item.total)}</CardTotal>
  </Card>
);
